import { useCallback } from 'react';
import { useAirportsWidgetConfig } from '../../../../../components/SearchForm/components/AirportsWidget/hooks/useAirportsWidgetConfig.js';
export function useRetriveData(airports) {
  const {
    retrieveCodes,
    retrieveSubRegions,
    retrieveRegions
  } = useAirportsWidgetConfig({
    airports
  });
  return useCallback(() => {
    return retrieveRegions().map(region => {
      const subRegions = retrieveSubRegions(region);
      const regionCodes = retrieveCodes(region);
      return {
        region,
        subRegions: subRegions.length ? subRegions.map(subRegion => ({
          subRegion,
          airports: retrieveCodes(subRegion) || []
        })) : [],
        airports: regionCodes || []
      };
    });
  }, [retrieveRegions, retrieveSubRegions, retrieveCodes]);
}